import makeService from './api';

export default makeService('contract_types');
